export default "__VITE_ASSET__CB58UBdt__"